<section class="w-full h-full bg-main-blue-light md:px-10 py-16 px-4">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="moreinfo|Need more info heading@@moreinfo.title"
        class="text-3xl font-semibold text-white tracking-wide"
      >
        Need more Info?
      </h2>
    </div>
    <div class="flex flex-col items-center justify-center gap-4 mt-2.5">
      <p
        i18n="moreinfo|Support subtitle@@moreinfo.subtitle"
        class="text-white text-center tracking-wide font-thin"
      >
        We here to support, Just Contact Us!
      </p>
    </div>
    <div class="flex flex-col items-center justify-center gap-4">
      <a
        class="bg-white text-main-blue-light md:w-fit w-full text-sm px-5 py-2.5 rounded-full flex items-center justify-center gap-2 cursor-pointer mt-10 hover:bg-main-yellow hover:text-white hover:border-0 transition-all duration-300 active:scale-95"
        href="https://lin.ee/qe4HGmS"
        target="_blank"
      >
        <span i18n="moreinfo|Contact us button@@moreinfo.contactUs"> Contact Us</span>
        <span>
          <img
            src="open_in_new_blue.svg"
            alt="Open in new tab"
            class="w-4 h-4 text-main-blue-light"
          />
        </span>
      </a>
    </div>
  </div>
</section>
